/* eslint-disable sonarjs/cognitive-complexity */

'use strict';

var loqate = require('./loqate');
var ajaxRequest = null;
var shippingAddressOneLoqate = '#shippingAddressOneLoqate';

/**
 * Determine if the if the form is using text boxes instead of drop downs
 * @returns {boolean} True if the form is using text boxes instead of drop downs
 * and false otherwise.
 */
function isTextMode() {
    return $(shippingAddressOneLoqate).attr('data-entry-mode') === 'text';
}

/**
 * Switched the address form from text entry mode to select mode
 */
function disableTextMode() {
    // Set the mode
    $(shippingAddressOneLoqate).attr('data-entry-mode', 'select');

    // Flip-flop field requiredness
    $('.text-mode input').removeAttr('required');
    $('.select-mode select').attr('required');

    // Show/hide input fields
    $('.text-mode').hide();
    $('.select-mode').show();

    // Disable the address verification modal
    $(shippingAddressOneLoqate).attr('data-bypass-verification', 'true');
}

/**
 * Set the state dropdown based of a matching loqate suggestedAddress
 * @param {string} countryCode - Country code to check
 * @param {Object} suggestedAddress - suggestedAddress to match on
 */
function populateStateDropdown(countryCode, suggestedAddress) {
    var suggestedProvince = suggestedAddress.Province;
    var shippingStateDropdown = $('#shippingState')[0];

    // Account for federal provinces for MY
    if (countryCode === 'MY') {
        suggestedProvince = suggestedProvince.replace('Wilayah Persekutuan ', '');
    }

    for (var i = 1; i < shippingStateDropdown.length; i += 1) {
        if (shippingStateDropdown[i].label === suggestedProvince) {
            $('#shippingState, #addressstateCode').val(shippingStateDropdown[i].id).data('suggestion', shippingStateDropdown[i].data);
            break;
        }
    }
}

/**
 * Set Default Values on the custom dropdown
 * @param {Object} responseData - jquery element
 */
function success(responseData) {
    if (responseData.success) {
        var countryCode = $('#shippingCountry').val();
        var suggestedAddress = responseData.text[0];
        // Codes that need to match province based off dropdown value vs code
        var countryCodesToCheck = ['MY', 'ZA'];

        var shippingAddressOne = loqate.removeHashFromAddress(suggestedAddress.Line1);
        var shippingAddressTwo = loqate.removeHashFromAddress(suggestedAddress.Line2);
        var shippingAddressThree = loqate.removeHashFromAddress(suggestedAddress.Line3);
        var postalCodeCityString = suggestedAddress.PostalCode + ' ' + suggestedAddress.City;

        if (countryCode === 'ZA') {
            shippingAddressThree = shippingAddressTwo; // In ZA Suburb = Line 2
            shippingAddressTwo = '';
        } else if (shippingAddressThree && shippingAddressThree !== postalCodeCityString) { // fix for MY
            shippingAddressTwo += ', ' + shippingAddressThree;
        }

        if (countryCode && (countryCode === 'HK' || countryCode === 'MO')) {
            $('#shippingAddressOne').val(shippingAddressOne).data('suggestion', shippingAddressOne);
            $(shippingAddressOneLoqate + ', #addressaddress2').val(shippingAddressTwo).data('suggestion', shippingAddressTwo);
            if (isTextMode()) {
                $('#shippingAddressCityText').val(suggestedAddress.City).data('suggestion', suggestedAddress.City);
                $('#shippingStateText').val(suggestedAddress.Province).data('suggestion', suggestedAddress.Province);
            }
        } else if (countryCode === 'TW') {
            $('#shippingAddressOneLoqate').val(shippingAddressOne).data('suggestion', shippingAddressOne);
            $('#shippingAddressTwo, #addressaddress2').val(shippingAddressTwo).data('suggestion', shippingAddressTwo);
        } else {
            $(shippingAddressOneLoqate).val(shippingAddressOne).data('suggestion', shippingAddressOne);
            $('#shippingAddressTwo, #addressaddress2').val(shippingAddressTwo).data('suggestion', shippingAddressTwo);
            $('#shippingAddressThree, #addressaddress3').val(shippingAddressThree).data('suggestion', shippingAddressThree);
            $('#shippingAddressCity, #addresscity').val(suggestedAddress.City).data('suggestion', suggestedAddress.City);
            $('#shippingState, #addressstateCode').val(suggestedAddress.Province).data('suggestion', suggestedAddress.Province);
            $('#shippingZipCode, #addresspostalCode').val(suggestedAddress.PostalCode).data('suggestion', suggestedAddress.PostalCode);
        }

        if (!$('#shippingState').val() && countryCodesToCheck.includes(countryCode)) {
            populateStateDropdown(countryCode, suggestedAddress);
        }

        $('#manualBypassAddressValidation').val('false');
        $(document).trigger('update:shippingMethodsList', '#shippingZipCode');
    } else if (isTextMode()) {
        disableTextMode();
    }
}

/**
 * Set Default Values on the custom dropdown
 * @param {Object} element - jquery element
 */
function fillShippingAddress(element) {
    var resultId = $(element).attr('data-id');
    var loqateAddressCaptureApiUrl = $('#addressSuggestionUrl').val();
    if (loqateAddressCaptureApiUrl && resultId) {
        loqate.removeAddressSuggestions();

        var url = loqateAddressCaptureApiUrl + '?result=' + resultId;
        $.ajax({
            url: url,
            type: 'POST',
            dataType: 'json',
            success: success,
            error: function () {
                if (isTextMode()) {
                    disableTextMode();
                }
            }
        });
        loqate.showAdditionalAddressFields();
        loqate.updateNeedsVerification(false);
    }
}

/**
 * init the verify address modal when proceeding to the payment step
 */
function initAddressVerificationModal() {
    $('#addressVerificationModal .form-check-input').on('change', function () {
        $('.address-summary').removeClass('selected');
        $(this).closest('.address-summary').addClass('selected');
        if ($(this).attr('id') === 'addressVerificationSuggested') {
            $(document).trigger('loqate:address-verification-modal-suggested'); // tracking
        } else {
            $(document).trigger('loqate:address-verification-modal-entered'); // tracking
        }
    });

    // wait a bit to put the focus on the suggested address
    setTimeout(function () {
        $('#addressVerificationModal #addressVerificationSuggested').trigger('focus');
    }, 1500);
}

/**
 * call the address validation service
 * @param {string} addressVerifyUrl - The addressVerifyUrl
 * @param {Object} shippingFormData - The shippingFormData
 * @param {boolean} advanceToNextStage - The advanceToNextStage
 * @returns {boolean} continueToSubmit
 */
function submitAddressValidation(addressVerifyUrl, shippingFormData, advanceToNextStage) {
    var continueToSubmit = false;

    if ($(shippingAddressOneLoqate).attr('data-bypass-verification')) {
        $.spinner().stop();

        continueToSubmit = true;
    } else {
        $.ajax({
            url: addressVerifyUrl,
            type: 'post',
            data: shippingFormData,
            async: false,
            success: function (data, textStatus, xhr) {
                $.spinner().stop();

                if (xhr.status === 200) {
                    $('#addressVerificationModal .modal-body').html(data);
                    $('#addressVerificationModal').modal('show');
                    $('body').trigger('checkout:enableButton', '.next-step-button button');
                    $('#advanceToNextStage').val(advanceToNextStage);
                    $(document).trigger('loqate:address-verification-modal-open'); // tracking
                    initAddressVerificationModal();
                } else {
                    continueToSubmit = true;
                }
            },
            error: function () {
                $.spinner().stop();

                continueToSubmit = true;
            }
        });
    }

    return continueToSubmit;
}

/**
 * Generated HTML of addresses for Suggestion
 * @param {string} containerId - address type container id
 * @param {Object} responseData - The responseData
 */
function successAddressSuggestions(containerId, responseData) {
    if (responseData.success) {
        var suggestionList = loqate.generateAddressSuggestionList(responseData.text);
        var $suggestions = $('.dropdown-address-suggestions');
        var $dropdownHeader = $suggestions.find('.dropdown-header');
        var $searchResults = $suggestions.find('.search-result');
        if (containerId) {
            $('.address-right').removeClass('d-none').addClass('d-block');
            $('.address-left').removeClass('d-block').addClass('d-none');
            var backToAddressLabel = $dropdownHeader.attr('data-back-to-address-label');
            var anchor = `
                <button class="p-0" aria-label="${backToAddressLabel}" id="backToResult" type="button">
                    <u>${backToAddressLabel}</u>
                </button>
            `;
            $dropdownHeader.empty().html(anchor);
            $suggestions.find('.address-right').html(suggestionList);
            $searchResults.addClass('search-right-animation').attr('data-suggestion-mode', 'container');
            $suggestions.find('.dropdown-item').removeClass('selected-color').attr('data-showdropdownaddresssuggestions', 'true');
            $(shippingAddressOneLoqate)[0].focus();
        } else {
            loqate.removeAddressSuggestions();
            var html = `
                <div class="address-left d-block" data-testid="address-suggestions-primary">
                    ${suggestionList}
                </div>
                <div class="address-right d-none" data-testid="address-suggestions-secondary"></div>
            `;
            var addressSuggestionLabel = $dropdownHeader.attr('data-address-suggestion-label');
            $dropdownHeader.empty().text(addressSuggestionLabel);
            $searchResults.append(html);
            $suggestions.show().attr('data-showdropdownaddresssuggestions', 'true');
        }
    } else {
        // with an error don't require the address verification modal
        loqate.handleManualAddress();
        loqate.updateNeedsVerification(false);
    }
}

/**
 * Generated HTML of addresses for Suggestion
 * @param {string} containerId - address type container id
 * @param {Object} containerString - string value of container type address
 */
function getAddressSuggestions(containerId, containerString) {
    if (ajaxRequest != null) {
        ajaxRequest.abort();
        ajaxRequest = null;
    }
    var shippingAddressValue = $(shippingAddressOneLoqate).val().trim();
    if (containerId) {
        shippingAddressValue = containerString;
    }
    var loqateShippingApiUrl = $('#addressSuggestionUrl').val();

    if (loqateShippingApiUrl && shippingAddressValue && shippingAddressValue.length > 0) {
        var url = `${loqateShippingApiUrl}?query=${shippingAddressValue}${containerId ? '&containerId=' + containerId : ''}`;

        var countryCode = $('#shippingCountry option:selected').val();
        if (countryCode) {
            url += '&countryCode=' + countryCode;
        }

        ajaxRequest = $.ajax({
            url: url,
            type: 'POST',
            dataType: 'json',
            success: function (responseData) {
                successAddressSuggestions(containerId, responseData);
            },
            error: function (request) {
                if (request.statusText === 'abort') {
                    return;
                }
                // with an error don't require the address verification modal
                loqate.handleManualAddress();
                loqate.updateNeedsVerification(false);
                if (isTextMode()) {
                    disableTextMode();
                }
            },
            complete: function () {
                ajaxRequest = null;
            }
        });
    }
}

module.exports = {
    initAddressVerificationModal: initAddressVerificationModal,
    submitAddressValidation: submitAddressValidation,
    fillShippingAddress: fillShippingAddress,
    getAddressSuggestions: getAddressSuggestions,
    isTextMode: isTextMode
};
